import { colors } from '../../colors';
var header = {
  primaryColor: colors.black,
  hoverColor: colors.deepOrange,
  borderColor: colors.overcast,
  bgColor: colors.white,
  barColor: colors.black,
  navContactLinkHoverTextDecoration: "underline",
  navUtilityLinkColor: colors.black,
  navUtilityLinkHoverColor: colors.black,
  navUtilityLinkTextDecoration: "none",
  navUtilityLinkHoverTextDecoration: "underline",
  topNavLineHeight: '14px'
};
export default header;